import React from 'react';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';

import sectionStyles from './index.module.css';
import AIAssistanceBackdrop from './AIAssistanceBackdrop';

class DetailAIAssistanceSection extends React.Component {
  render() {
    return (
      <section
        className={`${sectionStyles.pageSection} section`}
        data-anchor="AIAssistanceSection"
      >
        <AIAssistanceBackdrop />
        <Grid container spacing={0} className={`${sectionStyles.contentContainer} contentContainer`}>
          <Grid lg={6} xs={12} className={`${sectionStyles.contentContainer} contentContainer`} style={{ marginTop: 120 }}>
            <Grid container spacing={1} justify="center" className="articleTitleWithNumberContainerCenter">
              <Grid lg={1}>
                <div className={`${sectionStyles.articleTitleNumber} articleTitleNumber`}>
                  13
                </div>
              </Grid>
              <Grid lg={7}>
                <Hidden mdDown>
                  <div className="articleTitleNumberSubTitle">
                    Introduction to M3
                  </div>
                </Hidden>
                <div className={`${sectionStyles.sectionTitleContainer} float-left`} style={{ marginTop: 15 }}>
                  <div className={`${sectionStyles.articleBigTitle} articleBigTitle font-small`}>
                    AI Assistance
                  </div>
                  <div className={`sectionTitleUnderline ul-long ul-thin`} />
                  <div className={`${sectionStyles.articleTitle} articleTitle font-small`}>
                    Helpful answers and drafting, right where you work in M3.
                  </div>
                  <p className={`${sectionStyles.generalArticle} generalArticle font-small font-narrow`} style={{ marginTop: 20 }}>
                    AI assistance is built into the platform so your team can move faster on everyday tasks—whether
                    that is clarifying how something works, drafting member-facing messages, or getting suggestions
                    based on your data. You stay in control; the assistant is there to support your staff, not replace
                    your judgment.
                  </p>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </section>
    );
  }
}

export default DetailAIAssistanceSection;
